import React, { createRef } from 'react';
import classNameBind from 'classnames/bind';
import ActionList from '../../ActionList';
import styles from '../../../utils/hoc/WithAutocomplete/WithAutocomplete.module.css';
import getSuggestedItems from '../../../utils/hoc/WithAutocomplete/methods/getSuggestedItems';
import { KEYS } from '../../../utils/methods/keyboardKeys';

const bindClasses = classNameBind.bind(styles);

export default () => Component => (
  class WithSuggestions extends React.Component {
    wrapperRef = createRef();

    inputRef = createRef();

    static defaultProps = {
      suggestions: [],
    }

    state = {
      open: false,
      selected: null,
    }

    onSuggestedItemSelected = (suggestedItem) => {
      const { name, onChange } = this.props;

      onChange({
        target: {
          name,
          value: suggestedItem.value,
        },
      });
      this.inputRef.current.focus();
      this.setState({
        open: false,
        selected: null,
      });
    };

    handleFocus = () => {
      const { disabled } = this.props;

      if (disabled) return;

      this.setState({
        open: true,
      });
    }

    handleChange = (event) => {
      const { onChange } = this.props;

      onChange(event);
      this.setState({
        open: true,
        selected: null,
      });
    }

    handleKeyPress = (event) => {
      const { selected } = this.state;

      if (event.key === KEYS.ENTER) {
        event.preventDefault();
        this.onSuggestedItemSelected(selected);
        if (event.target.form) {
          event.target.form.removeEventListener('keypress', this.handleKeyPress);
        }
      }
    }

    handleKeyDown = (event) => {
      const { suggestions, value } = this.props;
      const { selected, open } = this.state;
      const items = getSuggestedItems(value, suggestions);

      if (!open || items.length === 0 || !([KEYS.ENTER, KEYS.UP, KEYS.DOWN].includes(event.key))) {
        return;
      }

      const selectedId = (selected || suggestions[0]).id;
      const selectedIndex = items.findIndex(item => (
        item.id === selectedId
      ));
      event.preventDefault();

      if (open && event.key === KEYS.ENTER) {
        this.onSuggestedItemSelected(selected);

        return;
      }

      if (event.key === KEYS.DOWN) {
        if (selected === null) {
          this.setState({
            open: true,
            selected: items[0],
          });

          return;
        }

        if (!selected && event.target.form) {
          event.target.form.addEventListener('keypress', this.handleKeyPress);
        }

        if (selectedIndex !== items.length - 1) {
          this.setState({
            open: true,
            selected: items[selectedIndex + 1],
          });
        }
      } else if (event.key === KEYS.UP && selectedIndex > 0) {
        this.setState({
          selected: items[selectedIndex - 1],
        });
      } else if (event.key === KEYS.UP && selectedIndex === 0) {
        this.setState({
          open: false,
          selected: null,
        });
      }
    }

    handleAutoCompleteBlur = (event) => {
      const { onBlur, name, value, disabled } = this.props;

      if (!this.wrapperRef.current.contains(event.relatedTarget) && !disabled) {
        this.setState({
          open: false,
        });
        if (onBlur) {
          onBlur({
            target: {
              name,
              value,
            },
          });
        }
      }
    }

    render() {
      const { open, selected } = this.state;
      const { suggestions, value } = this.props;
      const filteredItems = getSuggestedItems(value, suggestions);
      const current = selected ? selected.id : null;

      return (
        <div
          className={bindClasses('wrapper')}
          ref={this.wrapperRef}
          onBlur={this.handleAutoCompleteBlur}
        >
          <Component
            {...this.props}
            ref={this.inputRef}
            onFocus={this.handleFocus}
            onChange={this.handleChange}
            onKeyDown={this.handleKeyDown}
          />
          {open && filteredItems.length > 0 && (
            <div className={bindClasses('list')} style={{ width: this.wrapperRef.current.offsetWidth }}>
              <ActionList
                groups={[{
                  id: 0,
                  items: filteredItems.map((item) => {
                    const displayValue = item.displayValue || item.value;

                    return ({
                      ...item,
                      name: displayValue,
                    });
                  }),
                }]}
                onItemSelected={this.onSuggestedItemSelected}
                current={current}
              />
            </div>
          )}
        </div>
      );
    }
  }
);
